import produce from 'immer';
import * as _ from 'lodash';
import createSelector from 'selectorator';
import type { TeamsStore } from '.';
import type { Team as TypesTeam } from '../../types';
import type { ReduxStore } from '../store';

const getOrganizationId = (state, props) => props.organization && props.organization.id;

export type Team = Omit<TypesTeam, 'teamProjects' | 'teamUsers'>;

export type TeamsById = {
  [teamId: string]: Team;
};

const getTeams = createSelector(['teams.teams']);
const getTeamList = createSelector<TeamsStore, Team[]>([getTeams], _.values);

const getTeamsByOrganization =
  createSelector([getTeamList, getOrganizationId], (allTeams, organizationId): TeamsById => {
    return allTeams
      .reduce((coll, team) => {
        if (team.organizationId !== organizationId) {
          return coll;
        }
        const updatedTeam = produce(team, draftTeam => {
          if (team.teamUsers && !team.users) {
            draftTeam.users = team.teamUsers.map(u => u.userId);
          } else {
            draftTeam.users = draftTeam.users || [];
          }
          if (team.teamProjects && !team.projects) {
            draftTeam.projects = team.teamProjects.map(p => p.projectId);
          } else {
            draftTeam.projects = draftTeam.projects || [];
          }
          delete draftTeam.teamProjects;
          delete draftTeam.teamUsers;
        });
        coll[team.id] = updatedTeam;
        return coll;
      }, {});
  });

export default {
  getTeams,
  getTeamList,
  getStatus: createSelector(['teams.status']),
  getTeamsByOrganization,
  getTeamUpdatingStatus: (state: ReduxStore) => state.teams.teamUpdatingStatus,
  getPendingRemovedProjects: (state: ReduxStore) => state.teams.pendingRemovedProjects,
  getPendingRemovedReleaseGroups: (state: ReduxStore) => state.teams.pendingRemovedReleaseGroups,
  getPendingRemovedUsers: (state: ReduxStore) => state.teams.pendingRemovedUsers,
  getTeamSelection: (state: ReduxStore) => state.teams.teamSelection,
};
